import createLogic, { configureLogic } from './createLogic';
import createLogicMiddleware from './createLogicMiddleware';
export { configureLogic, createLogic, createLogicMiddleware };
export default {
  configureLogic: configureLogic,
  createLogic: createLogic,
  createLogicMiddleware: createLogicMiddleware
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-logic/build-es/index.js
// module id = 177
// module chunks = 11